(function (scope, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (scope) {
    const boot = () => scope.document.querySelectorAll('[data-bab-tiered]').forEach(api.hydrate);
    if (scope.document.readyState === 'loading') scope.document.addEventListener('DOMContentLoaded', boot, {once: true});
    else boot();
    scope.document.addEventListener('shopify:section:load', boot);
    scope.eleatHydrateNativeBundle = api.hydrate;
  }
})(typeof window === 'object' ? window : null, function () {
  'use strict';
  const sizes = [4, 6, 8, 10];
  const weeks = [4, 6, 8, 10, 12];
  const tiers = {4: 10, 6: 20, 8: 25, 10: 30};
  const pending = new WeakMap();
  const id = (value, type) => {
    const match = String(value || '').match(new RegExp(`^(?:gid://shopify/${type}/)?([1-9][0-9]*)$`));
    return match ? match[1] : '';
  };
  const money = value => {
    const cents = Number(value) * 100;
    if (!Number.isFinite(cents) || cents <= 0 || Math.abs(cents - Math.round(cents)) > 0.00001) throw new Error('price');
    return Math.round(cents);
  };
  function validate(config, response, cards) {
    const box = response?.ok === true ? response.DynamicBox : null;
    if (!box || !id(config.productPlatformId, 'Product') || box.boxId !== config.boxId || box.boxId === config.legacyBoxId || box.currencyCode !== 'GBP') throw new Error('box');
    if (JSON.stringify((box.sizeInterval || []).map(Number).sort((a, b) => a - b)) !== JSON.stringify(sizes) || box.sizeRange != null || box.priceRange != null) throw new Error('sizes');
    if (Object.values(box.fixedDiscountTier || {}).some(value => Number(value) !== 0)) throw new Error('fixed_discount');
    if (JSON.stringify(Object.keys(box.percentDiscountTier || {}).map(Number).sort((a, b) => a - b)) !== JSON.stringify(sizes)) throw new Error('tiers');
    if (sizes.some(size => Number(box.percentDiscountTier[size]) !== tiers[size])) throw new Error('tiers');
    const variants = new Map();
    for (const product of box.selectableProductVariants || []) {
      for (const variant of product.productVariants || []) {
        const key = id(variant.platformId, 'ProductVariant');
        if (!key || variants.has(key)) throw new Error('variant');
        variants.set(key, money(variant.price));
      }
    }
    if (!cards.length) throw new Error('cards');
    const plans = {};
    const cardPlans = {};
    for (const cadence of weeks) {
      const expected = id(config.plans[cadence], 'SellingPlan');
      const matches = Object.entries(box.sellingPlanGroup || {}).filter(([key, plan]) => id(key, 'SellingPlan') === expected && plan.interval === 'WEEK' && Number(plan.intervalCount) === cadence);
      if (matches.length !== 1) throw new Error('cadence');
      const [key, plan] = matches[0];
      if (plan.priceAdjustmentType !== 'PERCENTAGE' || Number(plan.priceAdjustmentAmount) !== 0) throw new Error('base_discount');
      plans[cadence] = id(key, 'SellingPlan');
      for (const card of cards) {
        const variantId = id(card.variantId, 'ProductVariant');
        const mapped = plan.variantMapping?.[`gid://shopify/ProductVariant/${variantId}`];
        const mappedPlan = id(mapped?.planId, 'SellingPlan');
        if (!variantId || !Number.isSafeInteger(card.price) || card.price <= 0 || variants.get(variantId) !== card.price || !mappedPlan || money(mapped.adjustedPrice) !== card.price || String(card.plans?.[cadence]) !== mappedPlan) throw new Error('mapping');
        (cardPlans[variantId] ||= {})[cadence] = mappedPlan;
      }
    }
    return {boxId: box.boxId, tiers: {...tiers}, plans, cardPlans};
  }
  function hydrate(root) {
    const node = root?.querySelector('[data-bab-tiered-config]');
    if (!node) return Promise.resolve(null);
    if (pending.has(root)) return pending.get(root);
    const contents = root.querySelector('.product-bundle__contents');
    const status = root.querySelector('[data-bab-tiered-status]');
    let config;
    let verified = false;
    let failed = false;
    const selectedSize = () => Number(root.querySelector('.build-a-bundle__size-button.active')?.dataset.size) || 6;
    const originalCopy = new WeakMap();
    const updateLabels = () => {
      if (!config) return;
      const percent = tiers[selectedSize()];
      root.querySelectorAll('[data-bab-tiered-quantity-tag]').forEach(label => {
        const size = Number(label.closest('.build-a-bundle__size-button')?.dataset.size);
        const isSubscription = contents?.dataset.purchaseType === 'subscription';
        const oneTimeSaving = {8: 5, 10: 10}[size];
        label.textContent = isSubscription
          ? config.savePercent.replace('__PERCENT__', tiers[size])
          : oneTimeSaving ? config.saveAmount.replace('__AMOUNT__', `£${oneTimeSaving}`) : '';
        label.hidden = !isSubscription && !oneTimeSaving;
      });
      root.querySelectorAll('[data-bab-tiered-copy]').forEach(copy => {
        const walker = document.createTreeWalker(copy, NodeFilter.SHOW_TEXT);
        let text;
        while ((text = walker.nextNode())) {
          if (!originalCopy.has(text)) originalCopy.set(text, text.textContent);
          const next = originalCopy.get(text).replace(/\b20\s*%/g, `${percent}%`);
          if (text.textContent !== next) text.textContent = next;
        }
      });
      root.querySelectorAll('.build-a-bundle__subscription-discount-percent').forEach(label => { label.textContent = String(percent); });
      root.querySelectorAll('.bab-plan-badge').forEach(label => { label.textContent = config.savePercent.replace('__PERCENT__', percent); });
    };
    const stopUnverifiedPurchase = event => {
      if (!(event.target instanceof Element) || !event.target.closest('.build-a-bundle__add-to-cart, .build-a-bundle__add-to-cart-mobile, .add-to-cart__submit, .add-to-cart__checkout')) return;
      if (!verified && contents?.dataset.purchaseType === 'subscription') {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (status) { status.hidden = false; status.textContent = (failed ? config?.errorCopy : config?.loadingCopy) || status.textContent; status.focus({preventScroll: true}); }
      }
    };
    document.addEventListener('click', stopUnverifiedPurchase, true);
    root.dataset.babTieredReady = 'false';
    const task = (async () => {
      try {
        config = JSON.parse(node.textContent);
        if (!contents) throw new Error('contents');
        const renderedTiers = JSON.parse(contents.dataset.bundleDiscounts || '{}');
        if (contents.dataset.dynamicBoxId !== config.boxId || contents.dataset.passDynamicBoxId !== 'true' || sizes.some(size => Number(renderedTiers[size]) !== tiers[size])) throw new Error('rendered_config');
        updateLabels();
        const observer = new MutationObserver(updateLabels);
        const sizeGroup = root.querySelector('.build-a-bundle__size-buttons');
        if (sizeGroup) observer.observe(sizeGroup, {subtree: true, attributes: true, attributeFilter: ['class']});
        observer.observe(contents, {attributes: true, attributeFilter: ['data-purchase-type']});
        const cards = Array.from(root.querySelectorAll('.bundle-card')).map(card => {
          const input = card.querySelector('.bundle-card__quantity-input');
          const select = card.querySelector('.bundle-card__subscription-dropdown');
          if (!input || !select) throw new Error('card');
          return {card, input, select, variantId: input.dataset.variantId, price: Number(input.dataset.oneoffPrice), plans: Object.fromEntries(Array.from(select.options).map(option => [Number(option.value.split('-')[0]), option.dataset.plan]))};
        });
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 10000);
        let response;
        try {
          response = await fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
            method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({productPlatformId: config.productPlatformId}), signal: controller.signal
          });
        } finally { clearTimeout(timeout); }
        if (!response.ok) throw new Error('response');
        const model = validate(config, await response.json(), cards);
        root.querySelectorAll('.build-a-bundle__size-button').forEach(button => {
          if (tiers[button.dataset.size] === undefined) throw new Error('size_button');
          button.dataset.discountPercent = String(tiers[button.dataset.size]);
          if (button.dataset.size === '10') button.removeAttribute('data-bab-desktop-only');
        });
        root.querySelectorAll('.build-a-bundle__type-subscription').forEach(button => {
          const cadence = Number(String(button.dataset.plan).split('-')[0]);
          if (!model.plans[cadence]) throw new Error('frequency_button');
          button.dataset.sellingPlanId = model.plans[cadence];
          button.dataset.discountPercent = '0';
        });
        root.dataset.babTieredReady = 'true';
        verified = true;
        updateLabels();
        if (status) status.hidden = true;
        root.dispatchEvent(new CustomEvent('eleat:bundle-tiered-ready', {bubbles: true}));
        return model;
      } catch (error) {
        failed = true;
        root.dataset.babTieredReady = 'false';
        if (status) { status.hidden = false; status.textContent = config?.errorCopy || status.textContent; }
        console.error('[ELEAT bundle] Tiered subscription pricing could not be verified', error.message);
        return null;
      }
    })();
    pending.set(root, task);
    return task;
  }
  return {validate, hydrate};
});
